import React from "react";

export const BoardButton = ({ item, activeItem, setActiveItem }) => {
  const isActive = activeItem?.name === item.name;

  return (
    <div
      className={`styling-wrap__type-item ${isActive ? "active" : ""}`}
      onClick={() => setActiveItem(item)}
    >
      {item.name}
    </div>
  );
};
